// extracted by mini-css-extract-plugin
export default {"roomsceneListContainer":"RoomSceneList_roomsceneListContainer__I6wxi","roomsceneList":"RoomSceneList_roomsceneList__ulfiA"};